import { useQuery } from 'react-query';
import { network } from 'services/network';

const getRelationshipTypeChangesTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getTopRelationshipTypeChanges', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryRelationshipTypeChangesTableData = (params) => {
    return useQuery(['relationshipTypeChangesTableData', params], () => getRelationshipTypeChangesTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
